import {
  type_webpage_catalogDownload,
  type_webpage_guideVisit,
  type_webpage_procurementMatchmaking,
  type_webpage_visitorPreRejst,
  type_webpage_aboutCIOSH,
  type_webpage_service,
  type_webpage_reserveCIOSH,
  type_webpage_zh
} from "../constants"
import *  as indexStateUtil from '@match/pages/index/store/stateUtil'
import *  as routerUtil from '@common/utils/routerUtil'
import {
  getExhibitionInfo,
  ajaxSystemMessageList,
} from '@common/api'

import {
  getNickName,
  getUserRoleType, getLoginUser
} from '@common/utils'
import findBrothersComponents from '@common/utils/vueFindComponent/findBrothersComponents.js'
import findComponentDownward from '@common/utils/vueFindComponent/findComponentDownward.js'
import findComponentsDownward from '@common/utils/vueFindComponent/findComponentsDownward.js'
import findComponentsUpward from '@common/utils/vueFindComponent/findComponentsUpward.js'
import findComponentUpward from '@common/utils/vueFindComponent/findComponentUpward.js'
import myalert from "@common/utils/myalert"
import bus from '@common/bus'
import { mapGetters } from "vuex"
import store from '../store/index'
import {
  type_checkbox, type_product_type, type_src_purchaser, type_src_supplier
} from "@common/constact.js"


export function getWebPageNameEn () {
  var params = window._vm.$route.params
  if (params.type == type_webpage_catalogDownload) {
    return window._vm.$t('lang.会刊下载')
  }
  if (params.type == type_webpage_guideVisit) {
    if (!isExhibitor()) {
      return window._vm.$t('lang.参观指引')
    } else {
      return window._vm.$t('lang.平台操作指引')
    }

  }

  if (params.type == type_webpage_procurementMatchmaking) {
    return window._vm.$t('项目推介会')
  }

  if (params.type == type_webpage_visitorPreRejst) {
    return window._vm.$t('lang.观众预登记')
  }
  if (params.type == type_webpage_aboutCIOSH) {
    return window._vm.$t('lang.展会介绍')
  }
  if (params.type == type_webpage_service) {
    return window._vm.$t('lang.综合服务')
  }
  if (params.type == type_webpage_reserveCIOSH) {
    return window._vm.$t('资料下载')
  }
}

export function getWebPageName () {
  var params = window._vm.$route.params
  console.log(params, '5566')
  if (params.type == type_webpage_catalogDownload) {
    return "会刊下载"
  }
  if (params.type == type_webpage_guideVisit) {
    if (!isExhibitor()) {
      return "参观指引"
    } else {
      return "平台操作指引"
    }
    // return "平台操作指引"
  }

  if (params.type == type_webpage_procurementMatchmaking) {
    return "项目推介会"
  }

  if (params.type == type_webpage_procurementMatchmaking) {
    return window._vm.$t('项目推介会')
  }

  if (params.type == type_webpage_visitorPreRejst) {
    return window._vm.$t('lang.观众预登记')
  }
  if (params.type == type_webpage_aboutCIOSH) {
    return window._vm.$t('lang.展会介绍')
  }
  if (params.type == type_webpage_service) {
    return window._vm.$t('lang.综合服务')
  }
  if (params.type == type_webpage_reserveCIOSH) {
    return window._vm.$t('lang.资料下载')
  }
}

export function getWebPageLink () {
  var params = window._vm.$route.params
  // 观众预登记
  if (params.type == type_webpage_visitorPreRejst) {
    return 'gzydj'
  }
  // 展会介绍
  if (params.type == type_webpage_aboutCIOSH) {
    return window._vm.g.isEn ? 'zhjsen' : 'zhjscn'
  }
  // 综合服务
  if (params.type == type_webpage_service) {
    return window._vm.g.isEn ? 'zhfwen' : 'zhfwcn'
  }
  // 资料下载
  if (params.type == type_webpage_reserveCIOSH) {
    return 'hkxz'
  }
  // 项目推荐会
  if (params.type == type_webpage_procurementMatchmaking) {
    return 'cgdjh'
  }
}

export function getIndexStoreState () {
  var stateUtil = require("@match/pages/index/store/stateUtil")
  return stateUtil.getState()
}

export function getIndexStoreState2 () {
  var stateUtil = require("@match/pages/index/store/stateUtil")
  return stateUtil.getState2.call(this)
}

// 栏目
export function getColumnByName (strEng) {
  var { webColunmsListObject } = getIndexStoreState()
  return webColunmsListObject[type_webpage_zh[strEng]]
}

export function go2Exhibitor () {
  routerUtil.push(`/exhibition`)
  return false
}

export function go2ExhibitorDetail (id) {
  routerUtil.push(`/exhibition/${id}`)
  return false
}

export function go2ExhibitDetail (id) {
  routerUtil.push(`/exhibit/${id}`)
  return false
}

export function go2Audience () {
  routerUtil.push(`/purchaser`)
  return false
}

export function computedIndex () {
  return this.$store.state.index
}

export function computedIsDesMobile () {
  return mapGetters("mobile", [
    "isDesMobile"
  ])
}


export function go2home () {
  if (getUserRoleType() == type_src_supplier) {
    routerUtil.push(`/exhibition`)
    return false
  }
  if (getUserRoleType() == type_src_purchaser) {
    routerUtil.push(`/purchaser`)
    return false
  }
  routerUtil.push(`/home`)
  return false
}

export function getNameByPathInNavHeader () {

}

export function setRouterByNavHeaderStateNavHeaderActive (newvalue) {
  // 展商登录：中英文导航栏名称修改，排列顺序：观众预登记、展会介绍、综合服务、采购需求、下届展位预订、采购商
  // 观众登录：中英文导航栏名称修改，排列顺序：观众预登记、展会介绍、综合服务、需求对接、下届展位预订、参展商

  if (newvalue == '首页') {
    go2home()
    return false
  } else if (newvalue == '观众预登记') {
    routerUtil.push(`/webpage/${type_webpage_visitorPreRejst}`)
    return false
  } else if (newvalue == '展会介绍') {
    routerUtil.push(`/webpage/${type_webpage_aboutCIOSH}`)
    return false
  } else if (newvalue == '综合服务') {
    routerUtil.push(`/compreService`)
    return false
  } else if (newvalue == '资料下载') {
    routerUtil.push(`/webpage/${type_webpage_reserveCIOSH}`)
    return false
  } else if (newvalue == '需求对接') {
    routerUtil.push(`/demandList`)
    return false
  } else if (newvalue == '采购商') {
    routerUtil.push("/purchaserList")
    return false
    // } else if (newvalue == '发布需求' || newvalue == '采购需求') {
    //   //是观众
    //   var user = getLoginUser()
    //   if (user.user2src !== type_src_purchaser) {
    //     routerUtil.push("/me/purchaser/requirement/add")
    //     return false
    //   } else {
    //     //是 展商
    //     routerUtil.push("/demandList")
    //     return false
    //   }
    //   return false
  } else if (newvalue == '采购需求' || newvalue == '发布需求') {
    var user = getLoginUser()
    //没有登录跳转登录
    if (user.id == null || user.id == undefined || user.id == '') {
      myalert.confirm("您未登录，请先登录再操作").then(isyes => {
        if (isyes) {
          routerUtil.push("/login")
          bus.$emit('getonbus', true)
          return false
        }
      })
      return false
    }
    routerUtil.push("/me/purchaser/requirement/add")
    return false
  } else if (newvalue == '展商展品') {
    routerUtil.push("/exhibitionList")
    return false
  } else if (newvalue == '参展商') {
    routerUtil.push("/exhibitionList")
    return false
  } else if (newvalue == '视频直播') {
    routerUtil.push("/livingList")
    return false
  } else if (newvalue == '项目推介会') {
    routerUtil.push(`/webpage/${type_webpage_procurementMatchmaking}`)
    return false
  } else if (newvalue == '平台操作指引') {
    routerUtil.push(`/webpage/${type_webpage_guideVisit}`)
    return false
  } else if (newvalue == '会刊下载') {
    routerUtil.push(`/webpage/${type_webpage_catalogDownload}`)
    return false
  } else if (newvalue == '个人中心') {
    var userType = getUserRoleType()
    if (userType == type_src_supplier) {
      routerUtil.push(`/me/exhibition`)
      return false
    } else {
      routerUtil.push(`/me/purchaser`)
      return false
    }
  } else if (newvalue == '参观指引') {
    routerUtil.push(`/webpage/${type_webpage_guideVisit}`)
    return false
  }
  else if (newvalue == '图片直播') {
    const link = store.state.index.colunmsListObject['图片直播'].detailList[0].link
    createA(link, "_black")
    // routerUtil.push(`/webpage/${type_webpage_guideVisit}`)
    return false
  }
  else {
    go2home()
  }
}

// go2全球大咖带你逛SIGN CHINA
export function go2globalBigCoffeeVisitSIGNCHINA () {
  routerUtil.push(`/worldLivingList`)
  return false
}

//go2 视频直播
export function go2ExhibitorLiveRoom () {
  routerUtil.push(`/livingList`)
  return false
}

//go2 专场项目推介会
export function go2SpecialProcurementMatchmaking () {
  routerUtil.push(`/webpage/${type_webpage_procurementMatchmaking}`)
  return false
}

//go2 会议直播
export function go2ConferenceLive () {
  routerUtil.push(`/classifyLivingList`)
  return false
}

//go2 热门采购商需求
export function go2PopularBuyerNeeds () {
  routerUtil.push(`/demandList`)
  return false
}

//修改个人的leftMenu 修改路由
export function changeLeftMenuRouter (str) {
  if (str == '我的需求') {
    routerUtil.push(`/me/purchaser/requirement`)
    return false
  }
  if (str == '我的预约') {
    routerUtil.push(`/me/purchaser/reservation`)
    return false
  }
  if (str == '我的日程') {
    routerUtil.push(`/me/purchaser/schedule`)
    return false
  }
  if (str == '我的消息') {
    routerUtil.push(`/me/purchaser/message`)
    return false
  }
  if (str == '点赞收藏') {
    routerUtil.push(`/me/purchaser/collectAndLike`)
    return false
  }

}

export function selectRoute_Exhibitor (str) {
  if (str == 'VR展台') {
    routerUtil.push(`/me/exhibition/vrbooth`)
    return false
  }
  if (str == '我的展品') {
    routerUtil.push(`/me/exhibition/list`)
    return false
  }
  if (str == '我的预约') {
    routerUtil.push(`/me/exhibition/reservation`)
    return false
  }
  if (str == '我的日程') {
    routerUtil.push(`/me/exhibition/schedule`)
    return false
  }
  if (str == '我的消息') {
    routerUtil.push(`/me/exhibition/message`)
    return false
  }
  if (str == '点赞收藏') {
    routerUtil.push(`/me/exhibition/collectAndLike`)
    return false
  }
  if (str == '我的直播') {
    routerUtil.push(`/me/exhibition/liveList`)
    return false
  }

}

export function setRouterIndex_Exhibitor (path) {
  if (path == '/me/exhibition/vrbooth') {
    this.routerIndex = 'VR展台'
    return false
  }
  if (path == '/me/exhibition/list') {
    this.routerIndex = '我的展品'
    return false
  }
  if (path == '/me/exhibition/reservation') {
    this.routerIndex = '我的预约'
    return false
  }
  // 我的日程
  if (path == '/me/exhibition/schedule') {
    this.routerIndex = '我的日程'
    return false
  }
  if (path == '/me/exhibition/message') {
    this.routerIndex = '我的消息'
    return false
  }
  if (path == '/me/exhibition/collectAndLike') {
    this.routerIndex = '点赞收藏'
    return false
  }
  if (path == '/me/exhibition/liveList') {
    this.routerIndex = '我的直播'
    return false
  }
}

export function go2top () {
  $("html,body").animate({ scrollTop: 0 }, 200)
}


export function isExhibitor () {
  var user = getLoginUser()
  return user.user2src == type_src_exhibitor
}

export function getLoginUser_ () {
  return getLoginUser()
}

export function getNickName_ () {
  return getNickName()
}

// 获取展商资料
export function getMyselfProfile () {
  var self = this
  return getExhibitionInfo().then(res => {
    const { result, message, code } = res
    if (code === '0') {
      self.info = result
    }
    return result
  })
}

//跳转个人中心界面
export function go2meSelfEdit () {
  if (isExhibitor()) {
    routerUtil.push(`/me/exhibition/profile`)
    return false
  } else {
    routerUtil.push(`/me/purchaser/profile`)
    return false
  }

}

/* begin im消息版主/
 */
import {
  initTIM, loginIM, eventlist
} from "../../common/utils/imUtils.js"
import * as MessageStoreUtil from '@match/store/message/MessageStoreUtil.js'
import { action_get_web_columnsList } from "../../match/pages/index/store/stateUtil"
import { setCookie, getCookie } from "@/common/utils"
import { createA, getProjectId, isNil, jsonParseSafe } from "../../common/utils"
import {
  demandDetail,
  getDemandList,
  getExhibitDetail,
  getExhibitionDetail,
  getPurchaserDetail,
  userLogout
} from "../../common/api"
import ajax from "@/common/utils/ajax"
import { type_src_demand, type_src_exhibitor, type_src_exhibits } from "../../common/constact"

export function imInit () {
  var userLogin = getLoginUser()
  initTIM()
  eventlist()
  loginIM(userLogin.id)
}

export function computedConversationList () {
  return MessageStoreUtil.getCurrentMessageList()
}

export function computedGetMessageState () {
  // return MessageStoreUtil.getMessageState()
}


export function showSystemMessagePage () {
  var dom = findComponentUpward(this, "messagePage")
  dom.isShowSystemMessage = true
}

export function getSystemMessageState () {
  var dom = findComponentUpward(this, "messagePage")
  return dom.isShowSystemMessage
}

export function closeSystemMessagePage () {
  var dom = findComponentUpward(this, "messagePage")
  dom.isShowSystemMessage = true
}

export function getSystemList () {
  return ajaxSystemMessageList().then(res => res.data)
}

export function go2BusinessMatching () {
  if (isExhibitor()) {
    routerUtil.push(`/me/exhibition/tradeMatchingActivities/list`)
    return false
  } else {
    routerUtil.push(`/me/purchaser/tradeMatchingActivities/list`)
    return false
  }
}

export async function cachewebColumnsList () {
  /*  var cachewebColumnsList = jsonParseSafe(getCookie("cachewebColumnsList"))
    if (!cachewebColumnsList ||
      cachewebColumnsList.length == 0
    ) {
      cachewebColumnsList = await action_get_web_columnsList()
    }
    setCookie("cachewebColumnsList",
      JSON.stringify(cachewebColumnsList || []),
      500,
      1 / (24 * 60) //2min过期
    )*/
  return await action_get_web_columnsList()
}

// 热门需求
export function ajaxPopularbuyerNeeds (userId) {
  this.tags = getUserTags()
  this.loading = true
  getDemandList({
    pageNum: 1,
    pageSize: 5,
    tags: this.tags,
    status: '1',
  }).then(res => {
    this.loading = false
    const { result, message, code } = res
    if (code === '0') {
      this.demondList = result.data
    }
  })
}

// 展商收藏
// 展品收藏
// 收藏我的采购商
// ---
// 展商点赞
// 展品点赞
// 点赞我的采购商
export function ajaxCollectList_Exhibitor () {

}

export function ajaxCollectList_Exhibits () {

}

export function ajaxCollectList_FavoriteMyBuyer () {

}

export function ajaxLikeList_Exhibitor () {

}

export function ajaxLikeList_Exhibits () {

}

export function ajaxLikeList_FavoriteMyBuyer () {

}

async function getCollectList (type) {
  var params = {
    "projectId": getProjectId(),
    "type": type,
    "passive": 0,
    "operation": 1,
    "userId": getLoginUser().id,
    "pageNum": 1,
    "pageSize": 998
  }
  var result = await ajax.get(`api/api3/livecollect/list`, params)
  if (result.code != 0) return []
  return result.result && result.result.data || []
}

async function getCollectListAll () {
  var old_zs_like_list = jsonParseSafe(getCookie("zs_collect_list")) || []
  var old_gz_like_list = jsonParseSafe(getCookie("gz_collect_list")) || []
  var old_cp_like_list = jsonParseSafe(getCookie("cp_collect_list")) || []
  var old_xq_like_list = jsonParseSafe(getCookie("xq_collect_list")) || []
  old_zs_like_list = old_zs_like_list && old_zs_like_list.filter(item => item.id)
  old_gz_like_list = old_gz_like_list && old_gz_like_list.filter(item => item.id)
  old_cp_like_list = old_cp_like_list && old_cp_like_list.filter(item => item.id)
  old_xq_like_list = old_xq_like_list && old_xq_like_list.filter(item => item.id)


  if (!old_zs_like_list || old_zs_like_list && old_zs_like_list.length == 0) {
    old_zs_like_list = await getCollectList(0)
  }
  if (!old_gz_like_list || old_gz_like_list && old_gz_like_list.length == 0) {
    old_gz_like_list = await getCollectList(1)
  }
  if (!old_cp_like_list || old_cp_like_list && old_cp_like_list.length == 0) {
    old_cp_like_list = await getCollectList(2)
  }
  if (!old_xq_like_list || old_xq_like_list && old_xq_like_list.length == 0) {
    old_xq_like_list = await getCollectList(3)
  }
  setCookie("zs_collect_list", JSON.stringify(old_zs_like_list))
  setCookie("gz_collect_list", JSON.stringify(old_gz_like_list))
  setCookie("cp_collect_list", JSON.stringify(old_cp_like_list))
  setCookie("xq_collect_list", JSON.stringify(old_xq_like_list))
}

//获取 点赞列表
async function getLikeList (type) {
  var params = {
    "projectId": getProjectId(),
    "type": type,
    "passive": 0,
    "operation": 0,
    "userId": getLoginUser().id,
    "pageNum": 1,
    "pageSize": 998
  }
  var result = await ajax.get(`/api/api3/livecollect/list`, params)
  if (result.code != 0) return []
  return result.result && result.result.data || []
}

async function getLikeListAll () {
  var old_zs_like_list = jsonParseSafe(getCookie("zs_like_list")) || []
  var old_gz_like_list = jsonParseSafe(getCookie("gz_like_list")) || []
  var old_cp_like_list = jsonParseSafe(getCookie("cp_like_list")) || []
  var old_xq_like_list = jsonParseSafe(getCookie("xq_like_list")) || []


  old_zs_like_list = old_zs_like_list && old_zs_like_list.filter(item => item.id)
  old_gz_like_list = old_gz_like_list && old_gz_like_list.filter(item => item.id)
  old_cp_like_list = old_cp_like_list && old_cp_like_list.filter(item => item.id)
  old_xq_like_list = old_xq_like_list && old_xq_like_list.filter(item => item.id)


  if (!old_zs_like_list || old_zs_like_list && old_zs_like_list.length == 0) {
    old_zs_like_list = await getLikeList(0)
  }
  if (!old_gz_like_list || old_gz_like_list && old_gz_like_list.length == 0) {
    old_gz_like_list = await getLikeList(1)
  }
  if (!old_cp_like_list || old_cp_like_list && old_cp_like_list.length == 0) {
    old_cp_like_list = await getLikeList(2)
  }
  if (!old_xq_like_list || old_xq_like_list && old_xq_like_list.length == 0) {
    old_xq_like_list = await getLikeList(3)
  }

  setCookie("zs_like_list", JSON.stringify(old_zs_like_list))
  setCookie("gz_like_list", JSON.stringify(old_gz_like_list))
  setCookie("cp_like_list", JSON.stringify(old_cp_like_list))
  setCookie("xq_like_list", JSON.stringify(old_xq_like_list))
}

export function ajaxTriggerAjaxLikeCollect (type, operation, passive, pageNum, pageSize) {
  return ajax.get('/api3/livecollect/list', {
    "userId": getLoginUser().id,
    [getLoginUser().contactId ? 'contactId' : '']: getLoginUser().contactId,
    type,
    operation,
    // "objectId": "",
    "projectId": getProjectId(),
    "passive": passive,
    pageNum,
    pageSize
  }).then(res => res.data)
}


export async function wrapperTriggerAjaxLikeCollect (type, operation, passive, pageNum, pageSize, isContact = false) {
  var result = await ajaxTriggerAjaxLikeCollect(type, operation, passive, pageNum, pageSize)
  var list = result.result.data
  console.log('list', list)
  this.pageNum = Number(result.result.pageNum)
  this.pageSize = Number(result.result.pageSize)
  this.total = Number(result.result.total)
  // console.log('1',result.result,result.result.data)
  var list_ = []
  for (let i = 0; i < list.length; i++) {
    //获取详细的信息
    if (list[i].type == type_src_exhibitor) {
      var one = list[i].supplier

      let id = list[i].id
      if (one) {
        // <!--        `type` int(1) DEFAULT NULL COMMENT '0:展商 1:观众 2:展品 3:需求',-->
        one.objectType = 0
        list_.push({
          ...list[i], ...one,
          type: list[i].type,
          [operation == '0' ? 'likeId' : 'collectId']: list[i].id
        })
      }

    }
    if (list[i].type == type_src_purchaser) {
      var one = list[i].purchaser
      // 被动的话，观众对应的是展商
      /* if(operation == 1) {
         one = list[i].supplier
       }*/
      if (one) {
        one.objectType = 1
        list_.push({
          ...list[i], ...one,
          type: list[i].type,
          [operation == '0' ? 'likeId' : 'collectId']: list[i].id
        })
      }
    }
    if (list[i].type == type_src_exhibits) {
      var one = list[i].exhibit
      if (one) {
        one.objectType = 2
        list_.push({
          ...list[i], ...one,
          type: list[i].type,
          [operation == '0' ? 'likeId' : 'collectId']: list[i].id
        })
      }
    }
    if (list[i].type == type_src_demand) {
      var one = list[i].demand
      if (one) {
        one.objectType = 3
        list_.push({
          ...list[i], ...one,
          type: list[i].type,
          [operation == '0' ? 'likeId' : 'collectId']: list[i].id
        })
      }
    }
  }
  if (isContact) { //默认每次加载都跟新整个array数据
    this.arrayList = list_
  }
  list_ = list_.map(item => {
    item.likeCollectVO = {
      // [operation == 0 ? 'likeId' : 'collectId']: item.id,
      [operation == '0' ? 'likeId' : 'collectId']: item.likeId || item.collectId,
    }
    return item
  })
  console.log('list_', list_)
  return list_
}

export function str2array (str) {
  if (!str) return []
  if (str.constructor === String) {
    return str.split(',')
  }
}

// <!--        ` '直播状态（ 0 直播中,1 暂停, 2 已结束）',-->
export function liveStatus2Str (num) {
  if (num == 0) return window._vm.$t('lang.直播中')
  // if (num == 1) return window._vm.$t('lang.暂停')
  if (num == 1) return window._vm.$t('lang.已结束')
  if (num == 2) return window._vm.$t('lang.已结束')
  return window._vm.$t('lang.直播中')
}
export function blockStr (str) {
  var str_ = ""
  if (!str) return ""
  if (str.length <= 2) {
    return str[0] + "*"
  }
  for (let i = 0; i < str.length; i++) {
    if (i < 1) {
      str_ += str[i]
    } else if (i > str.length - 2) {
      str_ += str[i]
    } else {
      str_ += "*"
    }

  }
  return str_
}

export function logout () {
  // return userLogout().then(res => {
  window.tim.logout && window.tim.logout()
  // console.log(res)
  setCookie("user2", "")
  sessionStorage.setItem("user2", "")
  setCookie("friendLink", "")
  setCookie("isImLogin", "")
  setCookie("companyId", "")
  setCookie("cachewebColumnsList", "")
  setCookie("set_recommendedPopupShow", "")
  setCookie("matchCgsType", "")
  setCookie("productTypeMap", "")
  setCookie("toDetail", "")
  location.href = `/pc?projectId=${getProjectId()}`
  // })
}

//是否 填写好了 个人信息需要
export function isComplateUserProfile () {
  var user = getLoginUser()
  //先判断是不是 观众
  if (user.user2src == type_src_purchaser) {
    if (isNil(user.contact)) {
      return false
    }
    return true
  }
  return true
}

export function getCompanyBlock (object) {
  var str = window._vm.g.lang == 'zh' ? object.company : object.companyEn
  var str_ = ""
  if (!str) return ""
  for (let i = 0; i < str.length; i++) {
    if (i < 1) {
      str_ += str[i]
    } else if (i > str.length - 2) {
      str_ += str[i]
    } else {
      str_ += "*"
    }
  }
  return str_
}

export function getCompanyBlockName (object) {
  var str = window._vm.g.lang == 'zh' ? object.company : object.companyEn
  var str_ = ""
  if (!str) return ""
  for (let i = 0; i < str.length; i++) {
    if (i < 1) {
      str_ += str[i]
    } else if (i > str.length - 3) {
      str_ += str[i]
    } else {
      str_ += "*"
    }
  }
  return str_
}

export function getContactBlock (object) {
  var str = window._vm.g.lang == 'zh' ? object.contact : object.contactEn
  var str_ = ""
  if (!str) return ""
  if (str.length <= 2) {
    return str[0] + "*"
  }
  for (let i = 0; i < str.length; i++) {
    if (i < 1) {
      str_ += str[i]
    } else if (i > str.length - 2) {
      str_ += str[i]
    } else {
      str_ += "*"
    }

  }
  return str_
}

export function getNameBlock (object) {
  console.log(object, 123)
  var str = window._vm.g.lang == 'zh' ? object.name : object.nameEn
  var str_ = ""
  if (!str) return ""
  if (str.length <= 2) {
    return str[0] + "*"
  }
  for (let i = 0; i < str.length; i++) {
    if (i < 1) {
      str_ += str[i]
    } else if (i > str.length - 2) {
      str_ += str[i]
    } else {
      str_ += "*"
    }

  }
  return str_
}

export function getContactBlockName (object) {
  var str = window._vm.g.lang == 'zh' ? object.contact : object.contactEn
  return str
}

export function getName (object) {
  console.log(object, '456')
  object.nameEn ? object.nameEn = object.nameEn : object.nameEn = object.name
  return object
}

export function setLangByUrl () {
  var url = location.href
  if (url.indexOf("=en") >= 0) {
    sessionStorage.setItem("lang", 'en')
    return 'en'
  }
  if (url.indexOf("=zh") >= 0) {
    sessionStorage.setItem("lang", 'zh')
    return 'zh'
  }
}


/*跳转其他系统 填写个人注册信息*/
export function go2RegisterForm () {
  routerUtil.push(`/purchaser/register`)
  return false
  // if (window._vm.g.isEn) {
  //   url = `https://register.ledchina.com/regform?id=5&source_id=1`
  // } else {
  //   url = `https://register.ledchina.com/regform?id=1&source_id=1`
  // }
  // if (window._vm.g.isSz) {
  //   // if (window._vm.g.isEn) {
  //   //   url = `https://register.ledchina.com/regform?id=5&source_id=1`
  //   // } else {
  //   //   url = `https://register.ledchina.com/regform?id=1&source_id=1`
  //   // }
  // }
  // if (!window._vm.g.isSz) {
  //   // if (window._vm.g.isEn) {
  //   //   url = `https://register.ledchina.com/regform?id=11&source_id=2`
  //   // } else {
  //   //   url = `http://register.ledchina.com/regform?id=9&source_id=2`
  //   // }
  // }

  // createA(url)
  // return false
}




// WEBPACK FOOTER //
// ./src/wenxing/utils/index.js